<script setup lang="ts">
import SidebarItem from "@/components/MyStudents/Navigation/SidebarItem.vue";
import type { NavigationSectionProps } from "@/components/OperationsApp/components/Navigation/types.ts";
import {
  hasPriceOverrideApprovalsAccess,
  hasStudentFulfillmentPermission,
  usePriceOverrides,
} from "@/composables/authorization";

defineOptions({ name: "StudentFulfillmentSection" });

const props = withDefaults(defineProps<NavigationSectionProps>(), {
  showHiddenNav: false,
  showHeader: false,
});

const emit = defineEmits(["menu-item-clicked"]);

const handleMenuItemClick = () => {
  emit("menu-item-clicked");
};
</script>

<template>
  <div data-testid="fulfillment-section">
    <div v-if="showHeader" class="mt-4" data-testid="fulfillment-title">
      <h2
        class="font-montserrat font-bold text-university-primary mb-2"
      >
        Student Fulfillment
      </h2>
      <hr class="border-t border-gray-475 mb-2" />
    </div>
    <ul class="space-y-2" data-testid="fulfillment-list">
      <SidebarItem
        v-if="hasStudentFulfillmentPermission"
        text="Fulfillment Home"
        :router-link="{
          name: 'student-fulfillment'
        }"
        data-test-id="fulfillment-item-price-overrides"
        @menu-item-clicked="handleMenuItemClick"
        mui-icon-name="box_edit"
        :enable-selected-links="true"
      />
      <SidebarItem
        v-if="hasPriceOverrideApprovalsAccess && usePriceOverrides"
        text="Price Override Approvals"
        :router-link="{
          name: 'price-override-approvals'
        }"
        data-test-id="fulfillment-item-price-overrides"
        @menu-item-clicked="handleMenuItemClick"
        mui-icon-name="price_change"
        :enable-selected-links="true"
      />
    </ul>
  </div>
</template>

<style scoped>

</style>
